"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PropertyCardPhotoWrapperMixin = void 0;
var _styledComponents = require("styled-components");
var _styledToken = _interopRequireDefault(require("styled-token"));
/** @class PropertyCardPhotoWrapperMixin */
/** @method */
var PropertyCardPhotoWrapperMixin = function PropertyCardPhotoWrapperMixin() {
  return (0, _styledToken.default)({
    borderRadius: 'PropertyCard.photo.borderRadius',
    templateRows: 'PropertyCard.photo.templateRows'
  }, function (_ref) {
    var borderRadius = _ref.borderRadius,
      _ref$templateRows = _ref.templateRows,
      templateRows = _ref$templateRows === void 0 ? 'auto 1fr auto' : _ref$templateRows;
    return (0, _styledComponents.css)(["display:grid;grid-area:photo;grid-template-areas:'photo-top' 'photo-center' 'photo-bottom';grid-template-rows:", ";border-radius:", "px;"], templateRows, borderRadius);
  });
};
exports.PropertyCardPhotoWrapperMixin = PropertyCardPhotoWrapperMixin;